import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import GoogleLogo from '@/assets/images/google-logo.svg';
import OutlookLogo from '@/assets/images/outlook-logo.svg';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // Blues
        primary: '#0077D5',
        primaryDark: '#0079C4',

        // Greens
        successLight: '#81C926',
        success: '#4ECE3D',
        successDark: '#40B630',

        // Grays
        darkerGray: '#2C405A',
        darkGray: '#3F536E',
        gray: '#8DABC4',
        lightGray: '#A8C6DF',
        lighterGray: '#C5D9E8',
        lightestGray: '#ECF5FD',
        whiteGray: '#FAFBFC',

        // Other
        error: '#FF5252',
        secondary: '#AB7DF6',
        info: '#26C1C9',
        warning: '#FACA00',
        blue: '#0077D5',
        blueDark: '#0074BC',
        blueLight: '#E3F4FF',
        green: '#549D01',
        black: '#505050',
        grey4: '#7A7A7A',
        grey3: '#DADADA',
        grey2: '#F8F9FC',
        grey1: '#F2F2F2',
        red: '#D9534F',
        white: '#FFFFFF',
      },
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      google: { component: GoogleLogo },
      outlook: { component: OutlookLogo },
    },
  },
});
